import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;
`;
